import PasswordForgot from './PasswordForgot';

export default PasswordForgot;